// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-058491be]{align-items:center;background:transparent;border:1px solid #1a1a1a;border-radius:50%;color:#1a1a1a;display:inline-flex;height:calc(2.5rem - 1px);justify-content:center;text-decoration:none;transition:background .25s;width:calc(2.5rem - 1px)}a [class^=icon][data-v-058491be]{color:#1a1a1a;font-size:1.25rem}a[data-v-058491be]:hover{background:#1a1a1a}a:hover [class^=icon][data-v-058491be]{color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
